<template>
  <div class="workload_radio">
    <div
      v-for="item in options"
      :key="item.value"
      :class="['workload_radio_item', item.value===selected.value ? 'active' : '']"
      @click="changeValue(item)"
    >
      <span>{{ item.title }}</span>
    </div>
  </div>
</template>

<script>

export default {
  name: 'WorkloadRadioGroupBy',
  components: { },
  props: {
    options: {
      type: Array,
      required: true,
    },

    value: {
      type: String,
      required: true,
    },

    ganttInstanceEventCaller: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      selected: this.options.find(item => item.value === this.value),
    };
  },
  methods: {
    changeValue(option) {
      if (this.selected.value === option.value) {
        return;
      }

      this.selected = option;
      this.ganttInstanceEventCaller('onChangeWorkloadViewMode', [option.value]);
    },
  },
};
</script>
